module.exports = __webpack_public_path__ + "img/avatar4.8c191d2f.png";